import React, { Component } from 'react'
import { connect } from 'react-redux';

import { customSecondsElapsedForMomentary } from '../actions/BehaviourDataActions'

class TimerForMomentary extends Component {

    componentDidMount = () => {
        this.props.newIncrementer.map((obj, index) => {
            return clearInterval(this.props.newIncrementer[0]);
        })
        if (this.props.isStart) {
            this.props.customSecondsElapsedForMomentary("mount")
        }
    } 

    componentWillUnmount = () => {
        this.props.incrementer.map((obj, index) => {
            return clearInterval(this.props.incrementer[0]);
        })
        if(!this.props.isSave){
            this.props.customSecondsElapsedForMomentary("unmount")
        }
    }

    getSeconds = () => {
        return ('0' + this.props.secondsElapsed % 60).slice(-2)
    }

    getMinutes = () => {
        return Math.floor(this.props.secondsElapsed / 60)
    }

    render() {
        return (
            <div>
                {this.getMinutes()}:{this.getSeconds()}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        isStart: state.patientRecordMomentaryCustomReducer.isStart,
        secondsElapsed: state.patientRecordMomentaryCustomReducer.secondsElapsed,
        incrementer: state.patientRecordMomentaryCustomReducer.incrementer,
        newIncrementer: state.patientRecordMomentaryCustomReducer.newIncrementer
    }
}

export default connect(mapStateToProps, {customSecondsElapsedForMomentary})(TimerForMomentary);




// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/BehaviorData/components/TimerForMomentary.js